<template>
<div class="home">
  <div class="home--page">
    首页
  </div>
  <div class="home-page-line"></div>
  <div class="home--market--mgr">
    <p class="market--mgr__title">
      营销工作台
    </p>
    <div class="market--mgr__item">
      <div class="mgr--docker__item" @click="handleToRoute('addfollowup')">
        <div class="iconfont title">&#xe608;</div>
        新增
      </div>
      <div class="mgr--docker__item" @click="handleToRoute('followup')">
        <div class="iconfont title">&#xe689;</div>
        营销日志
      </div>
      <div class="mgr--docker__item" @click="handleToRoute('market')">
        <div class="iconfont title">&#xe66f;</div>
        客户/渠道
      </div>
      <div class="mgr--docker__item" @click="handleToRoute('plain')">
        <div class="iconfont title">&#xe722;</div>
        下一步计划
      </div>
      <div class="mgr--docker__item mgr--docker__box" @click="handleToRoute('draftbox')">
        <div class="box--item" v-if="draftList.length>0">{{draftList.length}}</div>
        <div class="iconfont title">&#xe64f;</div>
        草稿箱
      </div>
      <div class="mgr--docker__item" @click="handleToRoute('help')">
        <div class="iconfont title">&#xe609;</div>
        帮助手册
      </div>
    </div>
  </div>
  <div class="home--market--line"></div>
  <div class="home--market--mgr">
    <p class="market--mgr__title">
      营销统计
    </p>
    <div class="market--mgr__item">
      <div class="mgr--docker__item" @click="handleToReport">
        <div class="iconfont title">&#xe601;</div>
        营销统计
      </div>
      <div class="mgr--docker__item" @click="handleToRoute('hismarket')">
        <div class="iconfont title">&#xe88a;</div>
        历史营销
      </div>
      <div class="mgr--docker__item" @click="handleToRoute('public')">
        <div class="iconfont title">&#xe604;</div>
        客户公海
      </div>
    </div>
  </div>
  <div class="home--market--line"></div>
  <div class="home--market--mgr">
    <p class="market--mgr__title">
      贷后管理
    </p>
    <div class="market--mgr__item">
      <div class="mgr--docker__item" @click="handleToRoute('custompool')">
        <div class="iconfont title">&#xe9d2;</div>
        客户回款
      </div>
    </div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { get, post } from '../api/api'
import recordPageTime from '../mixin/minin'
export default {
  name: 'Home',
  data () {
    return {
      draftList: [] // 草稿箱列表数据
    }
  },
  beforeMount () {
    this.getDraftBoxData()
  },
  methods: {
    handleToRoute (routerName, data) {
      if (routerName === 'draftbox') {
        console.log(this.draftList)
        this.$router.push({ name: routerName, params: { data: this.draftList } })
      } else {
        this.$router.push(routerName)
      }
    },
    // 获取草稿箱列表数据
    async getDraftBoxData () {
      const result = await get('/api/CBMS-APP/mmFollowRecord/list', {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      this.draftList = result.data.mmFollowRecordList.filter(item => item.couldEdit === true)
    },
    // 跳转到报表页面
    async handleToReport () {
      const result = await get('/api/CBMS-APP/mmReport/statistics', {})
      const tourl = result.data
      const fromurl = '/home'
      const time = 0
      const res = post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl, time })
      res.finally(() => {
        window.location.href = result.data
      })
      // window.location.href = result.data
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.home
  position : relative
  width : 100vw
  height : 100vh
  overflow-x : hidden
  background-color : #ffffff
  .home--page
    position : fixed
    top:0
    left :0
    width : 100%
    height : 85px
    line-height : 85px
    text-align : center
    background : #687591
    font-family: MyriadPro-Regular
    font-size: 38px
    font-weight: normal
    font-stretch: normal
    color: #ffffff
  .home-page-line
    width : 100%
    height : 85px
  .home--market--mgr
    .market--mgr__title
      margin : 0
      padding : 16px
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: 600
      font-stretch: normal
      letter-spacing: 0px
      color: #333333
    .market--mgr__item
      padding-bottom : 16px
      display : flex
      flex-wrap : wrap
      .mgr--docker__item
        width : 25%
        margin-top : 24px
        text-align : center
        font-size : 32px
        font-weight: normal
        font-stretch: normal
        letter-spacing: 0px
        color: #333333
        .title
          padding-bottom : 8px
          color : #4282e1
          font-size : 48px
      .mgr--docker__box
        position : relative
        .box--item
          position : absolute
          top:-15px
          right :40px
          width : 20px
          line-height : 20px
          padding : 4px
          text-align : center
          border : 1px solid #db4848
          border-radius : 50%
          font-size : 20px
          color : #db4848
  .home--market--line
    width : 100%
    height : 25px
    background-color : #f7f7f7
</style>
